import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link, useLocation } from "react-router-dom";
import { url } from "../helpers";
import { userContext } from "../context/UserContext";
import { toast } from "react-toastify";
import QaariPackageDetails from "../components/QaariPackageDetails";
import UserLoggedInWarning from "../components/UserLoggedInWarning";
import ReactPlayer from "react-player";
import ChooseDateTime from "../components/ChooseDateTime";
import OrderSuccessModal from "../components/OrderSuccessModal";
import { useTranslation } from "react-i18next";

function ZakiriDetail() {
  const { setLoad, AddToCart, user } = useContext(userContext);
  const [QaariAllDetails, setQaariAllDetails] = useState([]);
  const [Qaaripackages, setQaaripackages] = useState([]);
  const [QaariLinks, setQaariLinks] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [address, setAddress] = useState([]);
  const [showModal, setShowModal] = useState({
    show: false,
    details: null,
  });
  const { t } = useTranslation();

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const qaari_name = useQuery().get("name");

  useEffect(() => {
    async function QaariDetails() {
      setLoad(true);
      const response = await fetch(
        url + `resource/Qaari Zakreen/${qaari_name}`,
        {
          headers: {
            Authorization: "token 780df365e7e49ec:d6e94a18f55d1ce",
          },
        }
      );

      if (response.ok == true) {
        setLoad(false);
        const data = await response.json();
        console.log(data);
        setQaariAllDetails(data?.data);
        setQaaripackages(data?.data?.packages);
        setQaariLinks(data?.data?.links);
      } else {
        setLoad(false);
        toast.error("Internal Server Error");
      }
    }
    QaariDetails();
  }, [qaari_name]);

  useEffect(() => {
    if (showModal?.show) {
      setTimeout(() => {
        document.getElementById("trigger-Modal-booking").click();
      }, 500);
    }
  }, [showModal]);

  async function CreateCustomer() {
    const send_data = {
      data: {
        name: user?.message?.username,
        email: user?.message?.email,
        mobile_no: "9330668959", //usercontext missing field
        first_name: user?.message?.username,
        customer_name: user?.message?.username,
        custom_customer_email: user?.message?.email,
      },
    };

    const response = await fetch(url + "resource/Customer", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
      },
      method: "POST",
      body: JSON.stringify(send_data),
    });

    if (response.ok == true) {
      setLoad(false);
      const data = await response.json();
    } else {
      setLoad(false);
      // toast.error("Internal Server Error");
    }
  }

  async function FetchCurrentCustomer() {
    setLoad(true);
    const response = await fetch(
      url +
        `resource/Customer?fields=["*"]&limit_page_length=20&limit_start=0&filters=[["custom_customer_email", "=", "${user?.message?.email}"]]`,
      {
        headers: {
          Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
        },
      }
    );

    if (response.ok == true) {
      setLoad(false);
      const data = await response.json();
      if (data?.data?.length == 0) {
        CreateCustomer();
      } else {
        setCustomer(data?.data[0]);
      }
    } else {
      setLoad(false);
      // toast.error("Internal Server Error!");
    }
  }

  async function FetchPreviousAddress() {
    setLoad(true);
    const response = await fetch(
      url +
        `resource/Address?fields=["*"]&limit_page_length=20&limit_start=0&filters=[["Dynamic Link", "link_name", "like", "${customer?.name}"]]`,
      {
        headers: {
          Authorization: `token ${user?.message?.api_key}:${user?.message?.api_secret}`,
        },
      }
    );

    if (response.ok) {
      setLoad(false);
      const data = await response.json();
      setAddress(data?.data);
    } else {
      setLoad(false);
      // toast.error("Internal Server Error!");
    }
  }

  useEffect(() => {
    FetchCurrentCustomer();
  }, []);

  useEffect(() => {
    if (customer?.name) {
      FetchPreviousAddress();
    }
  }, [customer]);

  return (
    <div className="py-5">
      {showModal?.show && (
        <ChooseDateTime
          showModal={showModal}
          customer={customer}
          address={address}
          OnSuccess={() => {
            document.getElementById("choose-date-time-close-btn").click();

            setTimeout(() => {
              document.getElementById("request-sent-modal-trigger-btn").click();
            }, 500);
          }}
        />
      )}

      <button
        id="request-sent-modal-trigger-btn"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#Request-Sent-Modal"
        className="d-none"
      >
        REQUEST ORDER MODAL
      </button>

      <OrderSuccessModal />

      <button
        id="trigger-Modal-booking"
        data-bs-toggle="modal"
        data-bs-target="#Zakiri-Date-Modal"
        className="d-none"
      ></button>

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="breadrumb">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("common.home")}</Link>
                  </li>
                  <li className="breadcrumb-item text-primary">
                    {t("zakiriPage.vendorDetail")}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        <div className="resto-profile-div">
          <div className="resto-cover-img">
            {QaariAllDetails?.cover_picture ? (
              <img
                src={QaariAllDetails?.cover_picture}
                alt="img"
                className="img-fluid"
              />
            ) : (
              <img
                src="/assets/images/zakiri-banner.jpg"
                alt="img"
                className="img-fluid"
              />
            )}
          </div>
          <div className="resto-cover-bottom">
            <div className="resto-profile">
              {QaariAllDetails?.profile_picture ? (
                <img
                  src={QaariAllDetails?.profile_picture}
                  alt="img"
                  className="img-fluid"
                />
              ) : (
                <img
                  src="/assets/images/zakereen.png"
                  alt="img"
                  className="img-fluid"
                />
              )}
            </div>
            <div className="resto-name-detail">
              <h4>{QaariAllDetails?.qaari_name}</h4>
              <p>{t("zakiriPage.singer")}</p>
            </div>
          </div>
        </div>
        <div className="resto-description mt-4">
          <h5 className="font-regular">
            <u>{t("zakiriPage.description")}</u>
          </h5>
          <p className="text-light">{QaariAllDetails?.description}</p>
        </div>
        <hr />

        {user?.type != "guest" ? (
          <>
            {Qaaripackages?.length > 0 && (
              <div className="resto-item-list-div">
                <div className="row align-items-center mb-3">
                  <div className="col-12">
                    <h2 className="resto-item-title">{t("zakiriPage.choosingPackage")}</h2>
                  </div>
                </div>
                <div className="carosuel-div">
                  <OwlCarousel
                    className="owl-theme"
                    items={4}
                    dots={false}
                    loop={false}
                    margin={20}
                    responsive={{
                      0: { items: 1, nav: false },
                      768: { items: 2, nav: false },
                      992: { nav: true },
                    }}
                    nav
                  >
                    {Qaaripackages?.map((Qaaripackages, index) => (
                      <QaariPackageDetails
                        setShowModal={setShowModal}
                        Qaaripackages={Qaaripackages}
                        key={index}
                        QaariAllDetails={QaariAllDetails}
                      />
                    ))}
                  </OwlCarousel>
                </div>
              </div>
            )}

            {QaariLinks?.length > 0 && (
              <div className="resto-item-list-div mt-5">
                <div className="row align-items-center mb-3">
                  <div className="col-12">
                    <h2 className="resto-item-title">Videos</h2>
                  </div>
                </div>
                <div className="carosuel-div">
                  <OwlCarousel
                    className="owl-theme"
                    items={4}
                    dots={false}
                    loop={false}
                    margin={20}
                    responsive={{
                      0: { items: 1, nav: false },
                      768: { items: 2, nav: false },
                      992: { nav: true },
                    }}
                    nav
                  >
                    <div className="">
                      {QaariLinks?.map((QaariLink, index) => (
                        <div className="item m-3" key={index}>
                          {QaariLink?.zakreen_link ? (
                            <ReactPlayer
                              controls
                              url={QaariLink?.zakreen_link}
                            />
                          ) : (
                            <a
                              href="https://www.youtube.com/watch?v=ArrWdxG32QA"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="https://i.ytimg.com/vi/ArrWdxG32QA/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCLMxwzGT93_KOQUXhNLoJuRFNzqg"
                                alt="Video Thumbnail"
                                className="img-fluid"
                              />
                              <div className="pl-btn">
                                <i className="fas fa-play"></i>
                              </div>
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  </OwlCarousel>
                </div>
              </div>
            )}
          </>
        ) : (
          <UserLoggedInWarning />
        )}
      </div>
    </div>
  );
}

export default ZakiriDetail;
